<template>
    <div class="h-100">
        <div class="loader-cont" v-dxloader="isLoader"></div>   
        <div class="row h-100" v-show="!isLoader">
            <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
            <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
                <!-- Search for small screen-->
                <div class="container">
                    <div class="row">
                        <div class="col s10 m6 l6 alignLeft">
                            <h5 class="card-title alignLeft white-text">Users</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col s12 p-0" style="height:calc(100% - 45px)">
                <div class="container h-100 p-0">
                    <div class="section h-100 p-0">
                        <div class="row h-100 m-0">
                            <div class="col s12 m12 l12 h-100 p-0">
                                <div id="responsive-table" class="card card card-default scrollspy h-100 mb-0">
                                    <div class="card-content h-100">
                                        <div class="row">
                                            <div class="col s6 search-input">
                                                <div class="sidebar-search animate fadeUp">
                                                    <div class="search-area">
                                                        <i class="material-icons mr-2 search-icon">search</i>
                                                        <i class="material-icons mr-2 close-icon" v-show="searchText"  @click="searchText=''">close</i>
                                                        <input
                                                        type="text"
                                                        v-model="searchText"
                                                        placeholder="Search by name, mobile, email"
                                                        class="app-filter"
                                                        id="chat_filter"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row payinblock" style="height:calc(100% - 85px); overflow-y: auto">
                                            <div class="col s12 payinrowSubblock" style="height:calc(100% - 85px)">
                                                <table class="responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th data-field="index">S.No</th>
                                                            <th data-field="index">Name</th>
                                                            <th data-field="name">Email Address</th>
                                                            <th data-field="id">Mobile Number</th>
                                                            <th data-field="price">Audits</th>
                                                            <th data-field="total">Bookings</th>
                                                            <th data-field="date">Date Joined</th>
                                                            <th data-field="status">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item,index) in usersList.results" :key="item.id">
                                                            <td>{{index + 1}}</td>
                                                            <td>{{item.first_name || "-"}}</td>
                                                            <td>{{item.email || "-"}}</td>
                                                            <td>{{item.mobile_number}}</td>
                                                            <td>{{item.counter ? item.counter.audits : 0}}</td>
                                                            <td>{{item.counter ? item.counter.bookings : 0}}</td>
                                                            <td>{{item.date_joined | date('DD MMM YY, hh:mm a')}}</td>
                                                            <td>
                                                                <div class="switch">
                                                                    <label>
                                                                        <input :id="'toggle' + index" :name="'toggle' + index"  v-model="item.is_active" @change="onStatusChange($event,item)" type="checkbox">
                                                                        <span class="lever"></span>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                isLoader : true,
                usersList : {
                    results : [],
                    count : 0,
                    previous : null,
                    next : null
                },
                searchText : ""
            }
        },
        created(){
            this.listUsers();
             var thisObj = this;
            setTimeout(() => {
                Vue.scrollBottom("", () => {
                    if (thisObj.usersList.next) {
                        thisObj.listUsers(thisObj.usersList.next, true);
                    }
                })
            }, 500);
        },
        methods : {
            listUsers(q="",status=false) {
                let url = Constants.default.APIURL.Users + "?limit=10&q=" + q;
                return new Promise(resolve => {
                    ajax.get(
                    url,
                    res => {
                        this.isLoader = false;
                        if (status) {
                            let temp = this.usersList.results;
                            this.usersList = {
                                count: res.data.count,
                                previous: res.data.previous,
                                next: res.data.next
                            };
                            this.usersList.results = temp.concat(res.data.results);
                        } else {
                            this.usersList = res.data;
                        }
                        if(this.usersList.results.length==0){
                            Vue.showNoDataBlock('.payinrowSubblock');
                        }else{
                            Vue.hideNoDataBlock('.payinrowSubblock');
                        }

                    },err =>{
                        this.isLoader = false;
                    });
                });
            },
            onStatusChange(e, item) {
                let toggle = item.is_active;
                setTimeout(() => {
                    e.target.checked = !e.target.checked;
                }, 0);
                swal({
                    title: "Are you sure?",
                    text: `Do you want to ${!toggle ? 'disable' : 'enable'} this user`,
                    icon: 'warning',
                    dangerMode: !toggle,
                    buttons: {
                        cancel: true,
                        delete: `Yes, ${!toggle ? 'disable' : 'enable'}`
                    }
                }).then(async (willDelete) => {
                    if (willDelete) {
                        let result = await this.deActivatePackage(item.id);
                        if(result){
                            e.target.checked = !e.target.checked;
                            item.is_active = e.target.checked;
                        }
                    }
                });
            },
            deActivatePackage(id) {
                return new Promise((resolve) =>{
                    ajax.delete(
                        Constants.default.APIURL.DeactivateUsers + id , {},
                        res => {
                            resolve(true);
                        },
                        err => {
                            resolve(false);
                        }
                    );
                })
            }
        },
        watch: {
            searchText(text){
                this.listUsers(text);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .caps{
        text-transform: capitalize;
    }
    .search-input {
        .sidebar-search {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        // padding: 1rem 0;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -moz-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        }
        .search-area {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            width: -webkit-calc(100% - 0rem);
            width: -moz-calc(100% - 0rem);
            width: calc(100% - 0rem);
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }
        i {
            font-size: 1.45rem;
            height: 41px;
            margin-right: 0 !important;
            padding: 0.75rem 0.25rem 0.35rem 0.75rem;
            color: #9e9e9e;
            border-radius: 5px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            background-color: #eceff1;
        }
        .app-filter {
            height: 35px;
            margin-bottom: 0;
            padding: 0.2rem;
            color: #9e9e9e;
            border: none;
            border-radius: 5px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background-color: #eceff1;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            border-bottom: 0 !important;
            box-shadow: none !important;
        }
    }
    .search-area{
        i.close-icon{
            position: absolute;
            right: 10px;
            cursor: pointer;
            font-size: 18px;
            top: 22px;
            height: inherit;
            padding: 0;
            line-height: 0;
        }
    }
</style>

